import React from 'react';
import { NavLink } from 'react-router-dom';

import udafLogo from 'img/udaf-logo.png';
import Survey from 'components/Survey';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  appTitle: {
    fontSize: '2.5em',
    display: 'block',
    color: theme.custom.primary,
  }
}));
export default function AuthContainer({ hideHeader, children }) {
  const classes = useStyles();
  return <div className="login-container">
    <div className="login-content">
      {!hideHeader && <h4>
        <img src={udafLogo} className="logo" alt="Utah Department of Agriculture and Food" />
        <NavLink to="/" className={classes.appTitle}>Utah Brands</NavLink>
        <Survey />
      </h4>}
      {children}
    </div>
  </div>
}